import { createFileRoute } from '@tanstack/react-router';
import ProjectSettingsPage from '../pages/ProjectSettingsPage/ProjectSettingsPage';

export const Route = createFileRoute('/project_/$projectId_/settings')({
  component: ProjectSettingsPage,
});

